/* eslint-disable class-methods-use-this */
const { PaymentStrategies, getShortageDamageUnits, Metrics, movementMapLower } = require('pando-constants');
const { invert } = require('lodash');
const convert = require('convert-units');
const Helper = require('./utils/helper');

class Damage {
  getNetToleranceByWeight(weight) {
    let currentWeightValue = weight.value;
    if (weight && weight.unit.toLowerCase() === Metrics.Kg) {
      currentWeightValue = convert(weight.value).from(Metrics.Kg)
        .to(getShortageDamageUnits().MT.toLowerCase());
    }
    return currentWeightValue;
  }
  getNetDamageCount(material, currentCategory) {
    let damageCount = 0;
    if (material) {
      damageCount = (material.epod && material.epod.damage_count) || 0;
      if (currentCategory && currentCategory.damage_tolerance) {
        let netTolerance = material.quantity ? material.quantity.value : 0;
        if (currentCategory.damage_unit.toLowerCase() === getShortageDamageUnits().MT.toLowerCase()) {
          netTolerance = this.getNetToleranceByWeight(material.weight);
        }
        netTolerance *= 0.01 * (currentCategory.damage_tolerance || 0);
        damageCount = Math.max(damageCount - netTolerance, 0);
      }
    }
    return damageCount;
  }
  calculateChargeByCategory(material, category) {
    const type = category.damage_type.toString();
    const count = this.getNetDamageCount(material, category);
    const damageTypes = invert(PaymentStrategies.damage);
    let result = 0;
    switch (type) {
      case damageTypes.damageUsingFixedConstant:
        return count * category.damage_factor;
      case damageTypes.damageUsingFactorAndMrp:
        return count * category.damage_factor * material.mrp;
      case damageTypes.damageUsingInvoice:
        if (category.damage_unit
          && category.damage_unit.toLowerCase() === getShortageDamageUnits().MT.toLowerCase()) {
          const materialWeight = this.getNetToleranceByWeight(material.weight);
          result = count * category.damage_factor *
            (material.invoice.amount / materialWeight);
        } else {
          result = count * category.damage_factor *
          (material.invoice.amount / material.quantity.value);
        }
        return result;
      default:
        logger.warn('Unhandled damage type');
        return 0;
    }
  }
  damageUsingFixedConstant(data, clientConfiguration) {
    const computeSdcdAtCategoryLevel = Helper.getComputeSdcdAtCategoryLevel(clientConfiguration);
    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return { damage: 0 };
    }
    const materialShortageDamageMap = {};
    const factor = data.defectsSettings.damage.factor;
    const categoryMap = data.materials.category || {};
    const damageCharge = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((total, material) => {
        let totalCost = total;
        const locationId = destination.destinationGateId || destination.locationId;
        if(!materialShortageDamageMap[locationId]) {
          materialShortageDamageMap[locationId] = {};
        }
        const category = categoryMap[material.category];
        let calculatedCost;
        if (category && category.damage_type && computeSdcdAtCategoryLevel) {
          calculatedCost = this.calculateChargeByCategory(material, category);
        } else {
          calculatedCost = this.getNetDamageCount(material, category) * factor;
        }
        materialShortageDamageMap[locationId][material._id] = calculatedCost;
        totalCost += calculatedCost;
        return totalCost;
      }, 0), 0);
    return { damage: damageCharge.toFixed(2), materialShortageDamageMap };
  }
  damageUsingFactorAndMrp(data, clientConfiguration) {
    const computeSdcdAtCategoryLevel = Helper.getComputeSdcdAtCategoryLevel(clientConfiguration);
    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return { damage: 0 };
    }
    const categoryMap = data.materials.category || {};
    const factor = data.defectsSettings.damage.factor;
    const materialShortageDamageMap = {};
    const damageCharge = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((total, material) => {
        let totalCost = total;
        const locationId = destination.destinationGateId || destination.locationId;
        if(!materialShortageDamageMap[locationId]) {
          materialShortageDamageMap[locationId] = {};
        }
        const category = categoryMap[material.category];
        let calculatedCost;
        if (category && category.damage_type && computeSdcdAtCategoryLevel) {
          calculatedCost = this.calculateChargeByCategory(material, category);
        } else {
          calculatedCost = (this.getNetDamageCount(material, category) * factor * material.mrp);
        }
        materialShortageDamageMap[locationId][material._id] = calculatedCost;
        totalCost += calculatedCost;
        return totalCost;
      }, 0), 0);
    return { damage: damageCharge.toFixed(2), materialShortageDamageMap };
  }
  damageUsingInvoice(data, clientConfiguration) {
    const computeSdcdAtCategoryLevel = Helper.getComputeSdcdAtCategoryLevel(clientConfiguration);
    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return { damage: 0 };
    }
    const categoryMap = data.materials.category || {};
    const factor = data.defectsSettings.damage.factor;
    const materialShortageDamageMap = {};
    const damageCharge = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((total, material) => {
        let totalCost = total;
        const locationId = destination.destinationGateId || destination.locationId;
        if(!materialShortageDamageMap[locationId]) {
          materialShortageDamageMap[locationId] = {};
        }
        const category = categoryMap[material.category];
        const count = this.getNetDamageCount(material, category);
        let calculatedCost;
        if (category && category.damage_type && computeSdcdAtCategoryLevel) {
          calculatedCost = this.calculateChargeByCategory(material, category);
        } else if (category && category.damage_unit &&
          category.damage_unit.toLowerCase() === getShortageDamageUnits().MT.toLowerCase()) {
          const materialWeight = this.getNetToleranceByWeight(material.weight);
          calculatedCost = (count * factor *
          (material.invoice.amount / materialWeight));
        } else {
          calculatedCost = (count * factor *
          (material.invoice.amount / material.quantity.value));
        }
        materialShortageDamageMap[locationId][material._id] = calculatedCost;
        totalCost += calculatedCost;
        return totalCost;
      }, 0), 0);
    return { damage: damageCharge.toFixed(2), materialShortageDamageMap };
  }
  damageUsingAmount(data) {
    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return { damage: 0 };
    }
    const materialShortageDamageMap = {};
    const damageCharge = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((total, material) => {
        const locationId = destination.destinationGateId || destination.locationId;
        if(!materialShortageDamageMap[locationId]) {
          materialShortageDamageMap[locationId] = {};
        }
        const calculatedCost = (material.epod.damage_charge || 0);
        materialShortageDamageMap[locationId][material._id] = calculatedCost;
        return total + calculatedCost;
      }, 0), 0);
    return { damage: damageCharge.toFixed(2), materialShortageDamageMap };
  }
  getTotalDamage(data) {
    const categoryMap = data.materials.category || {};
    const damageCharge = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((each, material) =>
        each + this.getNetDamageCount(material, categoryMap[material.category]), 0), 0);
    return damageCharge;
  }
  getMaterialLevelDamage(data, clientConfiguration, materialShortageDamageMap = {}) {
    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return {};
    }
    return Helper.getMaterialLevelSdlc(data, clientConfiguration, 'damage_charge', materialShortageDamageMap);
  }
  damageUsingBaseFreight(data) {
    const freightCharge = data.overAllFreightRate;

    // Check for seal no.
    if (Helper.isSealIntact(data.sealNoDetails)) {
      return { damage: 0 };
    }
    const categoryMap = data.materials.category || {};
    const factor = data.defectsSettings.damage.factor;
    const tolerance = data.defectsSettings.damage.tolerance;
    const defectUnit = data.defectsSettings.damage.defectUnit;
    let totalMaterialCount = 0;
    const overAllDamage = data.allDestinations.reduce((acc, destination) =>
      acc + destination.materials.reduce((total, material) => {
        const currentCategory = categoryMap[material.category];
        if (defectUnit === getShortageDamageUnits().MT.toLowerCase()) {
          if (currentCategory &&
            currentCategory.damage_unit &&
            currentCategory.damage_unit.toLowerCase() === defectUnit) {
            totalMaterialCount += this.getNetToleranceByWeight(material.weight);
            total += (material.epod.damage_count || 0);
          }
        } else {
          totalMaterialCount += material.quantity.value;
          total += (material.epod.damage_count || 0);
        }
        return total;
      }, 0), 0);
    const consigneeDamage = data.destinations.reduce((acc, destination) =>
      acc + destination.paymentLevelMaterials.reduce((total, material) => {
        const currentCategory = categoryMap[material.category];
        if (defectUnit === getShortageDamageUnits().MT.toLowerCase()) {
          if (currentCategory &&
            currentCategory.damage_unit &&
            currentCategory.damage_unit.toLowerCase() === defectUnit) {
            total += (material.epod.damage_count || 0);
          } else {
            // skip material
          }
        } else {
          total += (material.epod.damage_count || 0);
        }
        return total;
      }, 0), 0);

    const damagePercent = (overAllDamage * 100) / totalMaterialCount;
    const netDamagePercent = Math.max(damagePercent - tolerance, 0);
    const netDamage = ((netDamagePercent * consigneeDamage) / overAllDamage) / 100;
    const damageCharge = netDamage * factor * freightCharge;
    const calculatedCost = (Math.round((damageCharge + Number.EPSILON) * 100) / 100);
    const materialShortageDamageMap = {};
    data.destinations.forEach((destination) => {
      destination.paymentLevelMaterials.forEach((material) => {
        const locationId = destination.destinationGateId || destination.locationId;
        if (!materialShortageDamageMap[locationId]) {
          materialShortageDamageMap[locationId] = {};
        }
        const cost =
          ((material.epod.damage_count || 0) / consigneeDamage) * calculatedCost;
        materialShortageDamageMap[locationId][material._id] = cost;
      });
    });
    return { damage: calculatedCost, materialShortageDamageMap };
    /*
      round to 2 decimal place

      reason to add EPSILON
      no EPSILON - 1.005 => 1
      with EPSILON - 1.005 => 1.01
    */
  }
}
module.exports = Damage;
